import Providers from "@/app/providers";
import { LegalModalProvider } from "@/context/LegalModalContext";
import { AuthErrorProvider } from "@/context/AuthErrorContext";
import { AuthErrorBoundary } from "@/components/AuthErrorBoundary";
import { AuthErrorInitializer } from "@/components/AuthErrorInitializer";
import { TenantProvider } from "@/context/TenantContext";
import { ToastProvider } from "@/context/ToastContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { LanguageProvider } from "@/context/LanguageContext";
import "@/styles/themes.scss";
import "@/styles/typography.scss";
import styles from "@/app/layout.module.scss";
import HeaderClient from "@/components/HeaderClient";
import FooterClient from "@/components/FooterClient";
import RoutePrefetcher from "@/components/RoutePrefetcher";
import LegalModal from "@/components/legal-modal/LegalModal";
import LegalConsentTrigger from "@/components/LegalConsentTrigger";
import KeepAlive from "@/components/KeepAlive";
import PageFeatureGuard from "@/components/FeatureGate/PageFeatureGuard";
import { TrialProvider } from "@/context/TrialContext";
import TrialBanner from "@/components/TrialBanner/TrialBanner";
import TrialGuard from "@/components/TrialGuard/TrialGuard";
import { Outlet } from "react-router-dom";
import { isAuthenticated } from "@/services/auth";

/**
 * Client-only shell mirroring `frontend/src/app/layout.tsx` without Next.js
 * server APIs (`headers`, `cookies`, `metadata`, font loaders).
 */
export default function RootLayout() {
  const serverIsLoggedIn = typeof document !== "undefined" && isAuthenticated();

  return (
    <div className={`${styles.body} font-inter-root`}>
      <Providers>
        <AuthErrorProvider>
          <AuthErrorInitializer />
          <TenantProvider>
            <ThemeProvider>
              <LanguageProvider>
                <ToastProvider>
                  <LegalModalProvider>
                    <AuthErrorBoundary>
                      <TrialProvider>
                        <HeaderClient serverIsLoggedIn={serverIsLoggedIn} />
                        <RoutePrefetcher />
                        <TrialBanner />
                        <main className={styles.main}>
                          <PageFeatureGuard>
                            <TrialGuard>
                              <Outlet />
                            </TrialGuard>
                          </PageFeatureGuard>
                        </main>
                        <FooterClient />
                        <LegalModal />
                        <LegalConsentTrigger />
                        <KeepAlive />
                      </TrialProvider>
                    </AuthErrorBoundary>
                  </LegalModalProvider>
                </ToastProvider>
              </LanguageProvider>
            </ThemeProvider>
          </TenantProvider>
        </AuthErrorProvider>
      </Providers>
    </div>
  );
}
